export default __webpack_public_path__ + "static/media/natachaetsachaa-Original.3b1afa64.jpg";